import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaChevronLeft } from 'react-icons/fa';

export default function FloatingBackButton({ docked = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => {
      setVisible(!!document.querySelector('.js-back-button') &&
        (docked || !document.querySelector('.dashboard-mobile-glass')));
    };

    updateVisibility();

    const observer = new MutationObserver(updateVisibility);
    observer.observe(document.getElementById('root') || document.body, {
      subtree: true,
      childList: true
    });

    return () => observer.disconnect();
  }, [location, docked]);

  const [isPeek, setIsPeek] = useState(true);

  useEffect(() => {
    if (docked) return;
    setIsPeek(true);
    const timerIn = setTimeout(() => setIsPeek(false), 10);
    const timerOut = setTimeout(() => setIsPeek(true), 1750);
    return () => {
      clearTimeout(timerIn);
      clearTimeout(timerOut);
    };
  }, [location.pathname, docked]);

  if (!visible) return null;

  const handleBack = () => {
    const customBackButton = document.querySelector('.js-back-button');
    if (customBackButton) {
      customBackButton.click();
      return;
    }

    const currentPath = window.location.pathname;

    if (window.history.length > 1) {
      navigate(-1);

      setTimeout(() => {
        if (window.location.pathname === currentPath) {
          navigate('/', { replace: true });
        }
      }, 60);
      return;
    }

    navigate('/', { replace: true });
  };

  return (
    <button
      className={docked ? 'mobile-glass-item mobile-glass-back' : `fab-back-button ${isPeek ? 'peek' : ''}`}
      type="button"
      onClick={handleBack}
      aria-label="Volver"
    >
      {docked ? <>
        <span className="mobile-glass-icon"><FaChevronLeft /></span>
        <span>Atrás</span>
      </> : <FaChevronLeft />}
    </button>
  );
}
